.page {
  position: relative;
  z-index: 1;
}

.content {
  padding-top: 68px;
}

@media (max-width: 900px) {
  .content {
    padding-top: 68px;
  }
}
